/**
 * Responsibility: Implement dialog media behavior for the ui/dialog surface.
 * Scope: Owns ui/dialog concerns only; cross-surface orchestration is excluded.
 */
import { generateImage } from '../../ai/imagen'
import { getItemImage, getNpcImage } from '../../engine/entity-images'
import * as gameStore from '../../game-store.js'

export async function resolveDialogImage(kind: unknown, seed: unknown) {
  const imageKind = String(kind ?? '').trim().toLowerCase()
  const imageSeed = String(seed ?? '').trim()

  if (!imageKind || !imageSeed) return null

  switch (imageKind) {
    case 'npc':
      return getNpcImage(imageSeed)
    case 'item':
      return getItemImage(imageSeed)
    case 'vision':
      const setting = gameStore.state?.world?.taxonomy?.imageStyle || gameStore.state?.world?.seed || 'Atmospheric fantasy environment'
      return generateImage(`Concept art of a location. Details: "${imageSeed}". Setting: ${setting}. Wide shot, immersive lighting, no text, no UI.`)
    default:
      return null
  }
}
